import React, { memo, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { getMeta } from './getMeta';
import gfmTable from "micromark-extension-gfm-table"
import gfmTableHtml from "micromark-extension-gfm-table/html"
import './index.scss';
import { load } from '../utils/api';
import micromark from "micromark"

interface IProps {
  source: string;
  fallback?: string | Array<string>;
  contentTransform?: (content: string) => string;
  base?: string
  onInit?: Function
  feedback?: boolean
  placeholder?: string
}

interface IState {
  content: string;
  status: 'loading' | 'ok' | 'error';
  title: string;
  meta: { direction?: string; title?: string };
}

const basePath = window.location.pathname.replace(/.*\/html\//, "").replace("/index.html", "").replace("/", "")

export const Layout = memo(({ source, fallback, contentTransform, base = basePath, onInit, feedback, placeholder = 'Network Error!' }: IProps) => {

  const [docData, setDocData] = useState<IState>({
    content: '',
    status: 'loading',
    title: '',
    meta: {}
  })

  const {content, status, title, meta} = docData
  useEffect(() => {
    // fallback有数据时再执行,避免重复加载md
    if (!fallback?.length) return
    (async () => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-array-constructor
        let data = (await load(`/${base}/${source}`, new Array().concat(fallback).map(t=>`/${base}/${t}`)))
        if (data === undefined) {
          throw Error("未找到语言")
        } else {
          if (contentTransform) {
            data = contentTransform(data || "")
          }
          const meta = getMeta(data)
          setDocData({
            ...docData,
            content: data,
            status: "ok",
            meta,
            title: meta.title ||
              data.match(/^(#+ +\**=?)(.*?)(?=\**[\n\r])/)?.[2] ||
              data.match(/^(\*\*)(.*?)(?=\*\*)/)?.[2] ||
              '\u200E'
          })
        }
      } catch (err) {
        console.log(err)
        setDocData({
          ...docData,
          status: "error"
        })
      }
    })();
  }, [source, fallback, contentTransform]);

  useEffect(()=>{
    if(status === 'ok'){
      setTimeout(()=>{
        if(onInit){
          onInit()
        }
      }, 1000)
    }
  }, [status])

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      {
        status === "ok" && (
          <div dangerouslySetInnerHTML={{__html: micromark(content, {
            allowDangerousHtml: true,
            extensions: [
              gfmTable
            ],
            htmlExtensions: [
              gfmTableHtml
            ]
          })}}></div>
        )
      }

      {status === 'loading' && <div className="infinity"/>}

      {status === 'error' && <div>{placeholder}</div>}

      {/* 防止长内容被反馈按钮遮挡 */}
      {feedback && <div style={{height:'11vw'}}/>}
    </>
  );
});
